import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType,  } from '@ngrx/effects';
import { exhaustMap, map, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ActivitiesService } from '../../service/activities.service';
import { UpdateService } from '../../service/update.service';
import * as schedulesActions from './schedules.actions';
@Injectable()
export class SchedulesEffects {
    constructor(private actions$: Actions, private activitiesService: ActivitiesService, private updateService: UpdateService) {
    }

    list$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schedulesActions.schedulesList),
            exhaustMap(() =>
                this.activitiesService.calendarManager().pipe(
                    map(response => schedulesActions.schedulesListSuccess({ schedules: response}))
                )
            )
        ));

    staffList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schedulesActions.staffList),
            exhaustMap(() =>
                this.activitiesService.getStaff().pipe(
                    map(response => schedulesActions.staffListSuccess({ staff: response}))
                )
            )
        ));


    activityList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schedulesActions.staffList),
            exhaustMap(() =>
                this.activitiesService.getActivities().pipe(
                    map(response => schedulesActions.activityListSuccess({ activities: response}))
                )
            )
        ));

    bookingMembersList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schedulesActions.bookingMembersList),
            exhaustMap((action) =>
                this.updateService.listMembersBooking(action.idSchedule).pipe(
                    map(response => schedulesActions.bookingMembersListSuccess({ bookingMembers: response}))
                )
            )
        ));

    updateSchedule$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schedulesActions.updateSchedule),
            exhaustMap((action) =>
                this.activitiesService.updateSchedule(action.schedule).pipe(
                    mergeMap((response) => [
                        schedulesActions.updateSchedule({ schedule: response }),
                        schedulesActions.updateScheduleSuccess({ success: true })
                    ]),
                    catchError((error) =>
                        of(schedulesActions.updateScheduleFailure({ errorMssg: error.error.errors[0].message }))
                    )
                )
            )
        )
    );
}
